export default "__VITE_ASSET__Cn$B11do__"